import React from 'react';
import { Flex, Heading, Text } from '@zillow/constellation-10';

export const PaymentTypeHeader: React.FC = () => (
  <Flex
    css={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'sm',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      paddingBottom: 'md',
    }}
  >
    <Heading level={2} css={{ textStyle: 'h4', lg: { textStyle: 'h3' } }}>
      What kind of payment do you need to make?
    </Heading>
    <Text>
      Whether you&apos;re depositing your earnest money after signing your contract or are nearing the finish line
      submitting funds for closing, we&apos;ll walk you through each option and step.
    </Text>
  </Flex>
);
